import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';
import ReactDOM from 'react-dom';
import invariant from 'tiny-invariant';
import canUseDOM from '../utils/canUseDom';

var createContainer = function createContainer(zIndex) {
  var container = document.createElement('div');
  container.setAttribute('class', 'atlaskit-portal');
  container.setAttribute('style', 'z-index: ' + zIndex + ';');
  return container;
};

var body = function body() {
  invariant(document && document.body, 'cannot find document.body');
  return document.body;
};

// This is a generic component does two things:
// 1. Portals it's children using React.createPortal
// 2. Creates the DOM node container for the portal based on props

var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Portal.__proto__ || _Object$getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      container: canUseDOM() ? createContainer(_this.props.zIndex) : undefined
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Portal, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var container = this.state.container;
      var zIndex = this.props.zIndex;

      if (container && prevProps.zIndex !== zIndex) {
        var newContainer = createContainer(zIndex);

        body().replaceChild(container, newContainer);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ container: newContainer });
      } else if (!prevState.container && container) {
        // SSR path
        body().appendChild(container);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var container = this.state.container;
      var zIndex = this.props.zIndex;

      if (container) {
        body().appendChild(container);
      } else {
        // SSR path
        var newContainer = createContainer(zIndex);
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ container: newContainer });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var container = this.state.container;

      if (container) {
        body().removeChild(container);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var container = this.state.container;

      return container ? ReactDOM.createPortal(this.props.children, container) : this.props.children;
    }
  }]);

  return Portal;
}(React.Component);

Portal.defaultProps = {
  zIndex: 0
};


export default Portal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/portal/dist/esm/components/Portal.js
// module id = 723
// module chunks = 0